var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "General / Navigation / Home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.67211 18.3176V16.116C9.67211 15.554 10.1401 15.0984 10.7173 15.0984H12.8276C13.1048 15.0984 13.3707 15.2056 13.5667 15.3965C13.7628 15.5873 13.8729 15.8462 13.8729 16.116V18.3176C13.8711 18.5512 13.9653 18.7759 14.1344 18.9417C14.3034 19.1075 14.5335 19.2008 14.7735 19.2008H16.2132C16.8856 19.2024 17.5311 18.9436 18.0072 18.4814C18.4832 18.0191 18.7508 17.3914 18.7508 16.7368V10.4649C18.7508 9.93615 18.51 9.43458 18.0934 9.09534L13.1957 5.28741C12.3438 4.61975 11.1231 4.6413 10.2966 5.33861L5.51077 9.09534C5.07445 9.42458 4.81367 9.92764 4.80078 10.4649V16.7304C4.80078 18.0948 5.93688 19.2008 7.33834 19.2008H8.74517C9.24366 19.2008 9.64877 18.8092 9.65239 18.324L9.67211 18.3176Z",
    fill: "#152946"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSidebar);
export default __webpack_public_path__ + "static/media/home-sidebar.b8ccc2b5e04ef1052e13a7897c509021.svg";
export { ForwardRef as ReactComponent };